import React from 'react';
import styles from './SectionTitle.css';

const SectionTitle = ({ title, icon }) => (
  <div className={styles.title}>
    <img src={icon} alt={title} />
    <h1>{title}</h1>
  </div>
);

export default SectionTitle;



// WEBPACK FOOTER //
// ./src/components/SectionTitle/index.js